import "babel-polyfill";
import "slick-carousel";
import "./libs/jquery.mCustomScrollbar";
import "./libs/jquery.mousewheel";

import {binder, fwa} from "./libs/binder";
import {detectDesktop} from "./modules/detectDesktop";
import {mobileMenu} from "./modules/mobileMenu";
import {servicesAccordion} from "./modules/servicesAccordion";
import {headerScroll} from "./modules/headerScroll";
import {bigGallery} from "./modules/bigGallery";
import {scrollAnimation} from "./modules/scrollAnimation";
import {parallax} from "./modules/parallax";
import {customScroll} from "./modules/customScroll";
import {googleMap} from "./modules/googleMap";
import {mainPhotoSlider} from "./modules/mainPhotoSlider";
import {stickySchedule} from "./modules/stickySchedule";


binder({
    bounds: {
        "html": detectDesktop,
        ".main-nav": [mobileMenu],
        ".services .accordion": servicesAccordion,
        ".header .btn-scroll": headerScroll,
        ".big-gallery": bigGallery,
        ".has-animate": scrollAnimation,
        ".has-parallax": parallax,
        ".custom-scroll": customScroll,
        ".header .photo": mainPhotoSlider,
        ".sticky-schedule": stickySchedule,
        "#map": googleMap
    },
    runTests: false
});


// WEBPACK FOOTER //
// ./assets/js/global.js